import React from "react";
import { Dialog, DialogSection } from "App/common/Dialog";
import { CopyButton } from "App/common/CopyButton";
import { TextInputV2 } from "App/common/TextInput/TextInputV2";
import { BUTTON_THEME } from "App/core/Button";
import { ReactComponent as LinkSVG } from "App/common/icons-v2/link.svg";
import { getAppDownloadUrl } from "App/modules/consts";
import styles from "./CopyDownloadLinkDialog.module.scss";

/**
 * Fallback for the Instagram in-app browser, where the app-store redirect from
 * the Download the App anchor sometimes never fires. DownloadAppButton opens
 * this on tap (Instagram only) WITHOUT blocking the navigation: if the redirect
 * lands, the user is gone anyway; if it chokes, they're looking at the download
 * link and a copy button to take it to a real browser. Styled to match
 * AppRequiredDialog.
 */
export const CopyDownloadLinkDialog = ({
  open,
  onRequestClose,
}: {
  open: boolean;
  onRequestClose: () => void;
}) => {
  const downloadUrl = getAppDownloadUrl();

  return (
    <Dialog
      className={styles.copyDownloadLink__container}
      open={open}
      onClose={onRequestClose}
      hideCloseButton
    >
      <DialogSection className={styles.copyDownloadLink__header}>
        <h3>DOWNLOAD LINK</h3>
        <p>
          Redirect not working? Copy and paste the download link directly into
          your browser.
        </p>
      </DialogSection>
      <DialogSection>
        <TextInputV2
          className={styles.copyDownloadLink__input}
          label="App download link"
          hideLabel
          inputType="input"
          disabled
          value={downloadUrl}
        />
      </DialogSection>
      <DialogSection>
        <CopyButton
          value={downloadUrl}
          theme={BUTTON_THEME.CTA}
          fullWidth
          endIcon={<LinkSVG />}
        >
          Copy Link
        </CopyButton>
      </DialogSection>
    </Dialog>
  );
};
